import { PropsWithChildren } from 'react';
import styles from './CardTable.module.scss';
import { VdsCard } from '@volt/volt-extended-components-react';
import { NoResults } from '@dmc/ui';

interface CardTableProps {
  hasData: boolean;
  noDataDescription: string;
}

export function CardTable({
  hasData,
  noDataDescription,
  children,
}: PropsWithChildren<CardTableProps>) {
  return (
    <div className={styles.container}>
      <VdsCard className={styles.card} padding="spacing-05">
        {hasData ? children : <NoResults description={noDataDescription} />}
      </VdsCard>
    </div>
  );
}

export default CardTable;
